import React from 'react';
import { Dialog, Button } from '@blueprintjs/core';
import {
  FlexRow,
  PaddingWrapper,
  PlainButton,
} from 'components/styled-components';

/*
 * A wrapper for Blueprint's Dialog component to keep them looking consistent
 * and reduce code repetition
 */

export const DialogWrapper = ({
  isOpen,
  onClose,
  title = 'You have unsaved changes on this page',
  body,
  confirm = 'LEAVE PAGE',
  action,
}) => (
  <Dialog isOpen={isOpen} onClose={onClose} title={title}>
    <PaddingWrapper>{body}</PaddingWrapper>
    <FlexRow justify="flex-end">
      <Button minimal onClick={onClose}>
        Cancel
      </Button>
      <PlainButton onClick={action}>{confirm}</PlainButton>
    </FlexRow>
  </Dialog>
);
